import React, { useEffect, useState } from 'react';
import { FiAlertTriangle } from "react-icons/fi";
import { getAccessToken } from '../../services/authApi';
import LoadingOverlay from '../shared/LoadingOverlay';
import elliemaeApi from '../../services/interceptors/elliemaeApi';

const Index = () => {
    const [loanId, setLoanId] = useState(null);
    const [token, setToken] = useState(null);
    const [fields, setFields] = useState([]);
    const [lockStatus, setLockStatus] = useState('');
    const [lockDate, setLockDate] = useState('');
    const [lockExpire, setLockExpire] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const init = async () => {
            try {
                window.elli?.script?.guest?.create?.();
                const loanObject = await window.elli.script.getObject('loan');
                const loan = await loanObject.all();
                setLoanId(loan.id);

                const authObject = await window.elli.script.getObject('auth');
                const authCode = await authObject.createAuthCode();
                const accessToken = await getAccessToken(authCode);
                setToken(accessToken);

                const response = await elliemaeApi.get(
                    `/secondary/v1/loans/${loan.id}/lockComparison`,
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                            'Content-Type': 'application/json',
                        },
                    }
                );

                const { lockDate, lockExpirationDate, lockValidationStatus, fields } = response.data;
                setFields(fields);
                setLockStatus(lockValidationStatus);
                setLockDate(lockDate);
                setLockExpire(lockExpirationDate);
            } catch (err) {
                console.error('Error fetching lock comparison:', err);
            } finally {
                setLoading(false);
            }
        };

        init();
    }, []);

    const diffCount = fields.filter(
        f =>
            (f.currentLoanValue ?? '').toString().trim() !==
            (f.currentLockValue ?? '').toString().trim()
    ).length;


    return (
        <>
            <LoadingOverlay loading={loading} text="Loading..." />

            <div className="space-y-10 p-25px">
                <div className="bg-white rounded-lg p-3 space-y-6 max-w-8xl mx-auto">
                    <h2 className="page-title">Lock Comparison</h2>

                    <div className="flex items-center justify-between pb-2 flex-wrap gap-4">
                        <div className="flex flex-wrap justify-start items-center gap-4 text-sm text-left">
                            <p className="text-gray-500">Field Changes: {diffCount}</p>
                            <p>Lock Date: {lockDate || '-'}</p>
                            <p>Expiration: {lockExpire || '-'}</p>
                            {lockStatus && (
                                <p className="text-red-600 flex items-center gap-1 w-full md:w-auto justify-start">
                                    <FiAlertTriangle
                                        size={20}
                                        className="text-orange-600 cursor-pointer relative"
                                    /> {lockStatus}
                                </p>
                            )}
                        </div>

                        <button
                            className="btn-custom rounded text-[#FFFFFF] bg-[#2080C3] hover:text-[#E6EEF8] hover:bg-[#5DA5D9] transition-colors duration-200"
                            onClick={() => {
                                window.elli.script
                                    .getObject('tpoApplication')
                                    .then(tpoApp => {
                                        tpoApp.pageRedirect('Product Pricing & Lock', {
                                            id: loanId
                                        });
                                    });
                            }}
                        >
                            Re-Price
                        </button>
                    </div>


                    <div className="overflow-x-auto">
                        <table className="w-full text-sm border-collapse mt-2">
                            <thead className="text-left"
                                style={{
                                    backgroundColor: 'rgb(238 238 238 / var(--tw-bg-opacity, 1))',
                                    color: 'var(--slate-grey-2)',
                                }}>
                                <tr>
                                    <th className="p-2 border w-1/4">Field Name</th>
                                    <th className="p-2 border w-1/4">Locked Value</th>
                                    <th className="p-2 border w-1/4">Current Loan Value</th>
                                </tr>
                            </thead>
                            <tbody>
                                {fields.map(f => (
                                    <tr key={f.lockFieldId}>
                                        <td className="p-2 border font-medium">{f.description}</td>
                                        <td className="p-2 border">{f.currentLockValue || '-'}</td>
                                        <td
                                            className={`p-2 border ${(f.currentLoanValue ?? '').toString().trim() !== (f.currentLockValue ?? '').toString().trim()
                                                ? 'bg-yellow-100 font-semibold text-red-700'
                                                : ''
                                                }`}
                                        >
                                            {f.currentLoanValue || '-'}
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Index;
